// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataCollapseTable_wrapper__2cC6J","nameCell":"DataCollapseTable_nameCell__1XOGo"};